import { useState } from 'react'

type Panel = 'none' | 'certificates' | 'subjects'

export const useMobileMenuPanel = () => {
  const [activePanel, setActivePanel] = useState<Panel>('none')
  return {
    activePanel,
    openPanel: (panel: Panel) => setActivePanel(panel),
    closePanel: () => setActivePanel('none'),
  }
}
